import { useAuthStateValue, useUserEmails } from '@/auth/authentication';
import { initDatadog } from '@/datadog';
import { applyDatadogSessionAttributes } from '@/utils/datadogSessionAttributes';
import { datadogRum } from '@datadog/browser-rum';
import { useEffect } from 'react';
import invariant from 'tiny-invariant';

export const useDatadog = () => {
    const authState = useAuthStateValue();
    const { currentUserEmail, spoofingUserEmail } = useUserEmails();

    useEffect(() => {
        if (!datadogRum.getInitConfiguration()) {
            initDatadog();
        }
    }, []);

    useEffect(() => {
        if (authState) {
            if (!datadogRum.getInitConfiguration()) {
                initDatadog();
            }
            invariant(currentUserEmail, 'Current user email is required');
            const user = {
                id: authState.uuid,
                email: authState.email,
                spoofing_user_email: spoofingUserEmail,
                org: {
                    name: authState.organization.name,
                    id: authState.organization.uuid,
                },
            };
            datadogRum.setUser(user);
            // `setUser` replaces the user object, so the feature flag and app config
            // attributes collected so far have to be re-applied on top of it.
            applyDatadogSessionAttributes();
        }
    }, [authState, currentUserEmail, spoofingUserEmail]);
};
